import { TableColumnGroupedPropsColumn, TableColumnGroupedPropsColumnConfiguration } from "shared/ui-kit";

import { ScreenerEtfBackendModel } from "../services/model";
import { ScreenerTable } from "../columns";

const ByCurrencyColumnConfigurations: { [key: string]: TableColumnGroupedPropsColumnConfiguration<ScreenerEtfBackendModel> } = {
	'RUB': makeColumnConfiguration('RUB'),
	'EUR': makeColumnConfiguration('EUR'),
	'USD': makeColumnConfiguration('USD'),
}

export default ByCurrencyColumnConfigurations;

function makeColumnConfiguration(currency: string): TableColumnGroupedPropsColumnConfiguration<ScreenerEtfBackendModel> {
	return {
		header: ScreenerTable.ticker.createTableColumn(currency),
		groups: ScreenerTable.groups.map(group => ({
			title: group.title,
			columns: group.columns.map(groupColumn => groupColumn.createTableColumn(currency)),
			defaults: {
				isExpanded: group.isExpandedByDefault
			}
		}))
	};
}